module.exports = __webpack_public_path__ + "images/application/templates/reset-password-alt@2x-dd823eb0.png";